@let showAnnotate = (loggedIn$ | async);
@let firstProblemId = (firstProblemId$ | async);
<nav
    class="navbar navbar-expand-lg bg-body-tertiary"
    aria-label="main navigation"
    data-bs-theme="dark"
>
    <div class="container-fluid">
        <div class="navbar-brand" i18n>LangPro Annotator</div>

        <button
            class="navbar-toggler"
            type="button"
            aria-controls="navigation-links"
            [attr.aria-expanded]="burgerActive"
            aria-label="toggle navigation"
            (click)="toggleBurger()"
            i18n-aria-label
        >
            <span class="navbar-toggler-icon"></span>
        </button>

        <div
            id="navigation-links"
            class="navbar-collapse"
            [ngbCollapse]="!burgerActive"
        >
            <ul class="navbar-nav">
                <li class="nav-item">
                    <a
                        [routerLink]="['/home']"
                        routerLinkActive="active"
                        class="nav-link"
                        i18n
                    >
                        Home
                    </a>
                </li>
                @if (showAnnotate && firstProblemId) {
                <li class="nav-item">
                    <a
                        [routerLink]="['annotate', firstProblemId]"
                        routerLinkActive="active"
                        class="nav-link"
                        i18n
                    >
                        Annotate
                    </a>
                </li>
                }
                <li class="nav-item">
                    <a
                        [routerLink]="['/about']"
                        routerLinkActive="active"
                        class="nav-link"
                        i18n
                    >
                        About
                    </a>
                </li>
            </ul>

            <ul class="navbar-nav ms-auto">
                <li class="nav-item">
                    <la-dark-mode-toggle role="listitem" class="nav-item" />
                </li>
                @if (languages) {
                <li class="nav-item" ngbDropdown>
                    <button
                        class="nav-link"
                        ngbDropdownToggle
                        id="language-dropdown-toggle"
                        aria-label="language"
                        i18n-aria-label
                    >
                        @if (loading) {
                        <span class="spinner-border spinner-border-sm"></span>
                        <span class="visually-hidden" i18n
                            >Loading languages...</span
                        >
                        } @else {
                        <fa-icon [icon]="faGlobe" aria-hidden="true" />
                        }
                    </button>
                    <div
                        ngbDropdownMenu
                        aria-labelledby="language-dropdown-toggle"
                        class="dropdown-menu dropdown-menu-end"
                    >
                        @for (language of languages; track $index) {
                        <button
                            ngbDropdownItem
                            class="navbar-item"
                            [class.active]="language.code == currentLanguage"
                            [attr.aria-pressed]="
                                language.code == currentLanguage
                            "
                            (click)="setLanguage(language.code)"
                        >
                            {{ language.name }}
                        </button>
                        }
                    </div>
                </li>
                }
                <la-user-menu />
            </ul>
        </div>
    </div>
</nav>
